'use client';

import React from 'react';

import styles from './dialog.module.scss';

export type DialogFooterProps = {
  children: React.ReactNode;
  align?: 'start' | 'center' | 'end' | 'space-between';
  className?: string;
  style?: React.CSSProperties;
};

export function DialogFooter({
  children,
  align = 'end',
  className,
  style
}: DialogFooterProps) {
  const alignClass =
    align === 'start'
      ? styles.footerStart
      : align === 'center'
        ? styles.footerCenter
        : align === 'space-between'
          ? styles.footerSpaceBetween
          : styles.footerEnd;

  return (
    <footer
      className={`${styles.footer} ${alignClass} ${className || ''}`}
      style={style}
    >
      {children}
    </footer>
  );
}
